import DefaultBlock from "../components/main/DefaultBlock";
import { Typography } from "@mui/material";
import { Box } from "@mui/material";

import BlueprintBlock from "../components/main/BlueprintBlock";
import SEO from "../components/misc/SEO";
import Portfolios from "../components/main/Portfolios";

export default function NotFound() {
  return (
    <div>
      <SEO
        title="Page Not Found"
        description="Uh oh. This page was not found!"
      />
      <BlueprintBlock
        text="HTTP/1.1 404 Not Found ::
content-type: application/json {
"
      />
      <DefaultBlock id="work-examples">
        <Typography variant="h2" sx={{ p: 2, maxWidth: "512px", opacity: 0.8 }}>
          Error 404
        </Typography>
        <Typography variant="h6" sx={{ p: 2, opacity: 0.8 }}>
          Yeah, this one's definitely my fault. Going to ask ChatGPT how to fix
          it now.
          <br />
          <br />
          Meanwhile, check out my new content:
        </Typography>

        <Box className="backgroundGrid">
          <Portfolios />
        </Box>
      </DefaultBlock>
    </div>
  );
}
